import * as Dialog from "@radix-ui/react-dialog";
import * as S from "./styles";
import { AiOutlineClose } from "react-icons/ai";
import { Button } from "../../Button";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

interface ModalProps {
  title: string;
  children?: ReactNode;
  isOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  modalContent: ReactNode;
  customButtons?: boolean;
  onSubmit?: () => void;
  width?: string;
}

export function Modal({
  children,
  customButtons = false,
  isOpen,
  onOpenChange,
  modalContent,
  onSubmit,
  title,
  width,
}: ModalProps) {
  const { t } = useTranslation();

  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      {children && <Dialog.Trigger asChild>{children}</Dialog.Trigger>}

      <Dialog.Portal>
        <S.Overlay>
          <S.ModalContent
            custombuttons={customButtons.toString()}
            width={width}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <S.TitleContainer>
              <S.ModalTitle>{title}</S.ModalTitle>

              <Dialog.Close asChild>
                <button aria-label={t("close")}>
                  <AiOutlineClose size={24} />
                </button>
              </Dialog.Close>
            </S.TitleContainer>

            <S.Content>{modalContent}</S.Content>

            {!customButtons && (
              <S.ButtonContainer>
                <Dialog.Close asChild>
                  <Button variant="ghost">{t("cancel")}</Button>
                </Dialog.Close>
                <Button onClick={onSubmit}>{t("save")}</Button>
              </S.ButtonContainer>
            )}
          </S.ModalContent>
        </S.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
